module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@3x-b2e746be8dcf158a43a6f3a9c3a084bd.png";